import { ProductFlowProps } from './index';

interface ResolveProductFlowParams {
  checkoutFlow: { flows: ProductFlowProps[] } | null | undefined;
  query: Record<string, string | string[]>;
}

export function resolveProductFlow({
  checkoutFlow,
  query,
}: ResolveProductFlowParams): ProductFlowProps | null {
  if (!checkoutFlow) return null;

  const flowId = query?.flowId
    ? query.flowId
    : query?.oferta
      ? 'offer'
      : 'default';

  return (
    checkoutFlow.flows.find((flow) => flow.id === flowId) ||
    checkoutFlow.flows[0] ||
    null
  );
}
